import React from 'react'
import styled from 'styled-components'

import { Columns, DiscoverMore, H2, H3, Screen, Section } from 'ui'

const Container = styled(Section.Light) `
  padding-top: 110px;
  padding-bottom: 10px;

  @media screen and (max-width: 640px) {
    padding-top: 94px;
    padding-bottom: 55px;
  }
`

const Title = styled(H2) `
  margin: 0px auto 85px auto;
  @media screen and (max-width: 640px) {
    margin-bottom: 70px;
  }
`

const Text = styled(H3) `
  margin-top: 10px;
  margin-bottom: 110px;

  @media screen and (max-width: 640px) {
    margin-bottom: 65px;
  }
`

const Third = styled(Columns.Column) `
  width: 33%;
  @media screen and (max-width: 640px) {
    width: 100%;
  }
`

const Point = ({ children }) => (
  <Third>
    <Text>{ children }</Text>
  </Third>
)

const Help = () => (
  <Container>
    <Screen>
      <Title>How can I help you achieve greatness</Title>
      <Columns>
        <Point>Creative Direction</Point>
        <Point>Marketing</Point>
        <Point>Communication</Point>
      </Columns>
      <Columns>
        <Point>Graphic Design</Point>
        <Point>Luxury Marketing</Point>
        <Point>Editorial Design</Point>
      </Columns>
      <Columns>
        <Point>Web Design</Point>
        <Point>Imaginery & VFX</Point>
        <Point>Event Design</Point>
      </Columns>
      <DiscoverMore />
    </Screen>
  </Container>
)

export default Help
